import { store } from '@/store/store'
import { Nullable, StrictNullable } from '@/shared/types/app.types'
import {
    FrontGlobalParametersDetailResponse,
    LaboratoryConfigurationResponse
} from '@/api/resources/common/initialization/common-initialization.dto'
import { LaboratoryStoreState, ModalsStoreState, RootStoreState, StoreStateModel } from '@/store/root/root-store.model'

export class StoreUtils {
    static get globalParameters(): Nullable<FrontGlobalParametersDetailResponse> {
        return store.state.parameters.global
    }

    static get selectedLaboratoryConfiguration(): LaboratoryConfigurationResponse | undefined {
        return store.state.laboratoriesConfiguration.find(
            laboratoryConfiguration => laboratoryConfiguration.laboratory.labId === store.state.labId)
    }

    static get laboratories(): LaboratoryStoreState[] {
        return store.state.laboratoriesConfiguration.map(laboratoryConfiguration => ({
            ...laboratoryConfiguration.laboratory,
            operationCodes: laboratoryConfiguration.operations.map(operation => operation.code)
        }))
    }

    static getModalConfirmationState(
        modalStateName: keyof ModalsStoreState,
        modalName: keyof ModalsStoreState[keyof ModalsStoreState]
    ): StrictNullable<ModalsStoreState[keyof ModalsStoreState]> {
        const modalState = store.state.modalsState[modalStateName]
        return modalState ? modalState[modalName] : null
    }
    static async setModalConfirmationState(
        name: StoreStateModel['name'],
        state: StoreStateModel['state']
    ): Promise<void> {
        const modalState: StoreStateModel = { name, state }
        await store.dispatch('setModalState', modalState)
    }

    static cleanSearchState(): void {
        store.commit('updateSearchState', null)
    }

    static updateLoading(state: RootStoreState['loading']): void {
        if (store.state.loading !== state) {
            store.commit('updateLoading', state)
        }
    }
    static updateShowUserDowntimeModal(state: boolean): void {
        if (store.state.showUserDowntimeModal !== state) {
            store.commit('updateShowUserDowntimeModal', state)
        }
    }
    static updateUserLoggedIn(state: boolean): void {
        if (store.state.userLoggedIn !== state) {
            store.commit('updateUserLoggedIn', state)
        }
    }
}
